import React, { useState, useEffect, useMemo } from "react";
import { Button, Col, Form, FormLabel, Modal, Row } from "react-bootstrap";
import * as HelpContent from "../../utils/HelpContent"
import { connect, useDispatch, useSelector } from "react-redux";
import TutorialPopup from "../help/TutorialPopup";
import Select from "react-select";
import { PRICE_ALERT_PAIR } from "../../actions/types";
import useInput from "../hooks/useInput";
import { createPriceAlert } from "../../actions/price-alert-action";
import Loading from "../common/Loading";
import { toast } from "react-toastify";
import SymbolSearchBox from "../bots/new-bot/modules/SymbolSearchBox";
const PriceAlertCreateModal = (props)=>{
    const {onHide,createPriceAlert,t} = props
    const selectedExchange = useSelector((state) => state.settings.selectedExchange) || {};
    const newAlert = useSelector((state) => state.priceAlert.newAlert) || {};
    const [loading, setLoading] = useState(false);
   
    const [baseCoin, setBaseCoin] = useState("usd");
    const dispatch = useDispatch();
    const usEquity = useSelector((state) => state.bots.usEquity);
    const btcPairs = useSelector((state) => state.bots.btcPairs);
    const ethPairs = useSelector((state) => state.bots.ethPairs);
    const [condition, bindCondition, setCondition] = useInput(newAlert.condition?newAlert.condition:"le");
    const [price, bindPrice, setPrice] = useInput(newAlert.price?newAlert.price:0);
    
    const pairList = useMemo(() => {
        return baseCoin === "usd"
          ? usEquity
          : baseCoin === "btc"
          ? btcPairs
          : ethPairs;
      }, [baseCoin]);
    const pairItems =
    (pairList &&
    pairList.map((item) => ({
        value: item.id,
        label: `${item.pair.from}/${item.pair.to}`,
        from: item.pair.from,
        to: item.pair.to,
    }))) ||
    [];
    const pair = newAlert.pair;
    const selectedPair = {
        value: newAlert.exchangePairId,
        label: `${pair.from}/${pair.to}`,
        from: pair.from,
        to: pair.to,
    };
    const handleSelectPair = (newPair) => {
        //const newPair = pairList.find((el) => item.value == el.id) || {};
        dispatch({
          type: PRICE_ALERT_PAIR,
          payload: newPair,
        });
      };
    const  restrictAlphabets = (e)=>{
    var x = e.which || e.keycode;
    if(!(x>=46 && x<=57))
        e.preventDefault()
    
    }
    const submitPriceAlert = ()=>{
        setLoading(true)
        let params = {
            exchange_id:selectedExchange.id,
            pair_id:pair.id,
            price:price,
            condition:condition,
        }
        createPriceAlert(params).then((res)=>{
            setLoading(false)
            toast.success(t("success"))
            onHide()
        }).catch((err)=>{
            toast.error(err.message)
            setLoading(false)
        })
    }
    return (
        <Loading show={loading} onHide={() => setLoading(false)}>
        <Modal show={true} onHide={onHide} size="lg" dialogClassName="modal-90w">
            <Modal.Header closeButton className="align-items-center">
              <Modal.Title>
               {t("create-p-alert")}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row>
                  <Col>
                  <Form.Group>
                    <Form.Label>
                        {t("exchange")} <TutorialPopup content={t("exchange-help")} />
                    </Form.Label>
                    <div className="mt-1 mb-3">
                        <img
                        src={selectedExchange.image}
                        width={20}
                        height={20}
                        style={{ marginRight: 10 }}
                        />
                        <span style={{ fontWeight: "bold", fontSize: 16 }}>
                        {selectedExchange.name}
                        </span>
                    </div>
                    </Form.Group>
                    <Form.Group style={{ marginTop: 20 }}>
                    <Form.Label>
                        Trading Pair 
                    </Form.Label>
                    <Row>
                        <Col style={{ maxWidth: "70%" }}>
                        <SymbolSearchBox selectedExchange={selectedExchange} selected={handleSelectPair} selectedPair={selectedPair}/>
                        </Col>

                        
                        </Row>
                        <Row>
                        <Col>
                        <div className="d-flex align-items-center price-alert-form mt-3">
                            <div>
                                <p>{t("alert-me-when-price")}</p>
                            </div>
                            <div>
                                <select {...bindCondition} className="form-control">
                                    <option value={`le`}>{t("less-than")}</option>
                                    <option value={`ge`}>{t("greater-than")}</option>
                                </select>
                            </div>
                            <div>
                                <Form.Control type="number" {...bindPrice} onKeyPress={(e) => {
                                    restrictAlphabets(e,e.target.value);
                                    }}></Form.Control>
                            </div>
                            <div>
                            <p className="bold">{pair.to}</p>
                            </div>
                        </div>
                        </Col>
                        </Row>
                       
                    </Form.Group>
                    <div className="d-flex justify-content-around">
                        <Button onClick={()=>onHide()} variant="secondary" className="width-200">
                        {t('cancel')}
                        </Button>
                        <Button onClick={()=>submitPriceAlert()} variant="success" className="width-200">
                        {t("save")}
                        </Button>
                        </div>
                  </Col>
              </Row>
              </Modal.Body>
            </Modal>
            </Loading>
    )

}
export default connect(null,{createPriceAlert})(PriceAlertCreateModal)
